import * as React from 'react';
import { Button } from '../Button';
import { Dialog, DialogProps } from './Dialog';
import { useIntlBds } from '../../translations/BdsIntlProvider';
import { BpDesignSystem } from '../../types';
import { FC } from 'react';

export type ConfirmDialogProps = BpDesignSystem.PropsWithChildren<
  Omit<DialogProps, 'fullScreen' | 'show'> & {
    loading?: boolean;
    show?: {
      /**
       * default: false
       */
      closeButton?: boolean;
    };
  }
>;

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  loading,
  show = { closeButton: false },
  dataTest,
  ...dialogProps
}) => {
  const { intl } = useIntlBds();
  return (
    <Dialog
      show={show}
      {...dialogProps}
      dataTest={dataTest ?? 'confirm_dialog'}
      actions={[
        <Button
          variant="text"
          key="cancel"
          onClick={dialogProps.onClose}
          disabled={loading}
          dataTest="cancel"
          children={intl.Dialog.ConfirmDialog.cancelLabel}
          {...dialogProps.slotProps?.cancelButton}
        />,
        <Button
          variant="contained"
          color="primary"
          onClick={dialogProps.onSubmit}
          dataTest="confirm"
          loading={loading}
          key="confirm"
          children={intl.Dialog.ConfirmDialog.confirmLabel}
          {...dialogProps.slotProps?.submitButton}
        />
      ]}
    />
  );
};
